import React, { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../../components/ui/dialog";

export default function ChangePasswordDialog({ open, onOpenChange }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const reset = () => { setCurrent(""); setNext(""); setConfirm(""); };
  const close = () => { reset(); onOpenChange(false); };

  const save = async () => {
    if (next.length < 6) { toast.error("New password must be at least 6 characters"); return; }
    if (next !== confirm) { toast.error("New passwords do not match"); return; }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password updated. Use your new password next time you log in.");
      close();
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) reset(); onOpenChange(v); }}>
      <DialogContent className="max-w-md" data-testid="change-password-dialog">
        <DialogHeader><DialogTitle>Change your password</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div><Label>Current password</Label><Input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} data-testid="change-pw-current" /></div>
          <div><Label>New password</Label><Input type="password" value={next} onChange={(e) => setNext(e.target.value)} data-testid="change-pw-new" placeholder="Min 6 characters" /></div>
          <div><Label>Confirm new password</Label><Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="change-pw-confirm" /></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={close} disabled={saving}>Cancel</Button>
          <Button onClick={save} disabled={saving || !current || !next} className="bg-[#2F5233] hover:bg-[#1F3D24] text-white" data-testid="change-pw-save">
            {saving ? "Saving…" : "Update password"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
